import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectLotPage } from './select-lot.page';

const routes: Routes = [
  { path: '', component: SelectLotPage }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectLotModuleRoutingModule { }
